<button id="upload_error__retry_button" (click)="retryInterview()">
  {{
    "record_interview.recorder.upload_error.button.retry_upload" | transloco
  }}
</button>
